$(document).ready(function() {
    // Select the first jar automatically on page load
  const firstJar = $(".jar-selection-section .link_hover:first");
    if (firstJar.length) {
        firstJar.parents(".addon-item").addClass("active");
     //   firstJar.parents(".addon-item").find(".image_hover").html(`<span>Awesome choice!</span>`).addClass("active");
        firstJar.parents(".addon-item").find(".link_hover").addClass("active");
    }
  });
$("body").on("click", ".jar-selection-section .link_hover", function (e) {
	// clear selection
	$(".jar-selection-section .addon-item").removeClass("active");
	$(".jar-selection-section .addon-item").find(".image_hover").removeClass("active");
	$(".jar-selection-section .addon-item").find(".link_hover").removeClass("active");

	// apply selected addons with indicator
	const stringArr = [
		"Awesome choice!",
		"They'll love it!",
		"It's in the bag!",
		"You're a goodie!",
//	].at(Math.floor(Math.random() * 3));
      ];
	const randomString = stringArr[Math.floor(Math.random() * 3)];
	e.preventDefault();
	$(this).parents(".addon-item").addClass("active");
	$(this)
		.parents(".addon-item")
		.find(".image_hover")
		.html(`<span>${randomString}</span>`)
		.addClass("active");
	$(this).parents(".addon-item").find(".link_hover").addClass("active");

	let height = "130px";
	let browserWidth = window.innerWidth;
	const jarId = $(this).parents(".addon-item").data("id");

	if (browserWidth < 800) height = "180px";
    console.log(jarId);
	if (jarId === 41962751000756 || jarId === 42742459531444) {
		$(".personalized-input-container.jar").css("height", height);
		$(".personalized-input-container.jar input").focus();
	} else {
        $(".personalized-input-container.jar").css("height", 0);
		$(".personalized-input-container.jar input").val("");
    }

	updateTotalPrice();
});

$("body").on("click", ".jar-selection-section .image_hover", function (e) {
	e.preventDefault();
	$(this).parents(".addon-item").removeClass("active");
	$(this).parents(".addon-item").find(".image_hover").removeClass("active");
	$(this).parents(".addon-item").find(".link_hover").removeClass("active");

    $(".personalized-input-container.jar").css("height", 0);
    $(".personalized-input-container.jar input").val("");

	updateTotalPrice();
});
